import React from "react";
import "./About.css";

const teamMembers = [
  { name: "Alice Johnson", role: "Founder & CEO", img: "https://i.pravatar.cc/150?img=1" },
  { name: "Bob Smith", role: "Lead Stylist", img: "https://i.pravatar.cc/150?img=2" },
  { name: "Carol White", role: "Spa Specialist", img: "https://i.pravatar.cc/150?img=3" },
  { name: "David Brown", role: "Makeup Artist", img: "https://i.pravatar.cc/150?img=4" },
];

export default function About() {
  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <h1>About Our Salon & Spa</h1>
        <p>
          We bring beauty, wellness, and professional care together. Our team is dedicated to creating
          the ultimate experience for every guest. Quality, hygiene, and style are our top priorities.
        </p>
      </section>

      {/* Values / Services */}
      <section className="about-values">
        <div className="value-card">
          <div className="value-icon">💇‍♀️</div>
          <h3>Professional Care</h3>
          <p>Trained experts ensure your hair, skin, and nails are handled with precision.</p>
        </div>
        <div className="value-card">
          <div className="value-icon">✨</div>
          <h3>Premium Experience</h3>
          <p>From ambience to service, we provide a luxurious and relaxing experience.</p>
        </div>
        <div className="value-card">
          <div className="value-icon">🧴</div>
          <h3>Quality Products</h3>
          <p>We use only high-quality, trusted products for all our services.</p>
        </div>
      </section>

      {/* Team */}
      <section className="about-team">
        <h2>Meet Our Experts</h2>
        <div className="team-grid">
          {teamMembers.map((member, idx) => (
            <div className="team-card" key={idx}>
              <div className="team-img" style={{ backgroundImage: `url(${member.img})` }}></div>
              <h4>{member.name}</h4>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="about-cta">
        <h2>Ready to Glow?</h2>
        <p>Book your appointment today and experience the difference.</p>
        <button className="btn-primary">Book Now</button>
      </section>
    </div>
  );
}
